import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import _ from "lodash";
import TimeStamp from "react-timestamp";
import SwitchBtn from "./SwitchBtn";
import { confirmAlert } from "react-confirm-alert";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";

// Css
import "../../assets/css/groupmanagement.css";

import LocalizedStrings from "react-localization";
import { getMergedGroupLocks } from "./GroupLocksHelper";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    viewLocksBtn: "View Locks",
    groupLocksHeader: "Group Locks",
    nameHeader: "Lock Name",
    lockSerialHeader: "Lock Serial",
    shareModeHeader: "Share Mode",
    startHeader: "Start",
    endHeader: "End",
    normalGrantAccess: "Normal Grant Access",
    multiApproveAccess: "Multi Approve Access",
    multiApproveOneTimeAccess: "Multi Approve & One Time Access",
    oneTimeAccess: "One Time Access",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    noDataTitle: "There is no data to display",
  },
  ja: {
    viewLocksBtn: "ロック一覧",
    groupLocksHeader: "登録スマートロック",
    nameHeader: "ロック名",
    lockSerialHeader: "ロックシリアル",
    shareModeHeader: "共有モード",
    startHeader: "アクセス開始日",
    endHeader: "アクセス終了日",
    normalGrantAccess: "アクセス譲渡",
    multiApproveAccess: "承認者追加",
    multiApproveOneTimeAccess: "承認者追加＆ワンタイム解錠",
    oneTimeAccess: "ワンタイム解錠",
    resultTitle1: "表示 ",
    resultTitle2: " へ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    noDataTitle: "表示するデータがありません。",
  },
  es: {
    viewLocksBtn: "Ver Candados",
    groupLocksHeader: "Candados del Grupo",
    nameHeader: "Nombre de la Candado",
    lockSerialHeader: "Número de Serie de la Candado",
    shareModeHeader: "Modo de Compartir",
    startHeader: "Inicio",
    endHeader: "Fin",
    normalGrantAccess: "Acceso Normal Concedido",
    multiApproveAccess: "Acceso con Aprobación Múltiple",
    multiApproveOneTimeAccess: "Aprobación Múltiple y Acceso Único",
    oneTimeAccess: "Acceso Único",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    noDataTitle: "No hay datos para mostrar",
  },
});

// const customConfirmDialog = (next, dropRowKeys) => {
//   //   // this.setState({show : true});
//   confirmAlert({
//     title: "Confirm retract access",
//     message: "Retract all selected access to users ?",
//     buttons: [
//       {
//         label: "Confirm",
//         onClick: () => next()
//       },
//       {
//         label: "Cancel",
//         onClick: () => {
//           return false;
//         }
//       }
//     ]
//   });
// };

export class LockDetailsButton extends Component {
  constructor(props) {
    super(props);

    const cell = this.props.cellValue;
    const row = this.props.rowValue;

    var grouplockarray = [];
    _.map(row.groupLocks, (lockData) => {
      // console.log(lockData);
      const eachLock = {
        id: lockData.snapID,
        lockName: lockData.Name,
        lockSerial: lockData.ip45SerialNumber,
        shareMode: lockData.sharingMode,
        startDate: lockData.shareStartTime,
        endDate: lockData.shareEndTime,
        access: lockData,
      };
      grouplockarray.push(eachLock);
    });

    this.state = {
      _notificationSystem: null,
      cell: cell,
      row: row,
      showPopup: false,
      groupID: row.groupID,
      groupLocksArrayList: grouplockarray,
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
      isLoading: false, // ✅
      groupSharedInstances: [], // ✅
    };

    this.handleGroupLocksPopupOpen = this.handleGroupLocksPopupOpen.bind(this);
    this.handleGroupLocksPopupClose = this.handleGroupLocksPopupClose.bind(
      this,
    );
    // this.onAfterDeleteRow = this.onAfterDeleteRow.bind(this);
    this.isASharedMode = this.isASharedMode.bind(this);
    this.checkStartDate = this.checkStartDate.bind(this);
    this.checkEndDate = this.checkEndDate.bind(this);
    this.renderBtn = this.renderBtn.bind(this);
  }

  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();

            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;

              if (eachMemberEmail === auth.currentUser.email) {
                const superAdminID = superAdmin.key;
                this.setState({
                  isAdmin: eachMemberDetails.isAdmin,
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                  superAdminID: superAdminID,
                });
              }
            }
          });
        }
      });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      // customLog(item)
      // customLog(item.key)

      returnArr.push(item);
    });
    // customLog(returnArr)
    return returnArr;
  };

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  fetchGroupSharedInstances = async () => {
    const { superAdminID } = this.state;
    const groupID = this.state.row.groupID;

    if (!superAdminID || !auth.currentUser?.uid || !groupID) return [];

    const snap = await fire
      .database()
      .ref("lockGroupManagement")
      .child(superAdminID)
      .child(auth.currentUser.uid)
      .once("value");

    const results = [];

    snap.forEach((lockGroupSnap) => {
      const lockGroupId = lockGroupSnap.key;

      const shared = lockGroupSnap.child("sharedInstances");
      if (!shared.exists()) return;

      shared.forEach((instSnap) => {
        const inst = instSnap.val() || {};

        // ✅ match your real schema from screenshot
        if (inst.recipientType === "GROUP" && inst.recipientUID === groupID) {
          results.push({
            lockGroupId,
            instanceId: instSnap.key,
            ...inst,
          });
        }
      });
    });

    // ✅ PRINT RESULT HERE
    // console.log("fetchGroupSharedInstances results:", results);
    customLog("fetchGroupSharedInstances results", results);

    return results;
  };

  fetchUserLocksMap = async () => {
    const snap = await fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .once("value");

    const mapBySerial = {};
    snap.forEach((child) => {
      const v = child.val() || {};
      const serial = v.ip45SerialNumber;
      if (serial) {
        mapBySerial[serial] = { id: child.key, ...v };
      }
    });

    return mapBySerial;
  };

  fetchLockGroupLocksSerials = async (lockGroupId) => {
    const { superAdminID } = this.state;

    const snap = await fire
      .database()
      .ref("lockGroupManagement")
      .child(superAdminID)
      .child(auth.currentUser.uid)
      .child(lockGroupId)
      .child("locks")
      .once("value");

    const serials = [];
    if (snap.exists()) {
      snap.forEach((child) => {
        const serial = child.val();
        if (serial) serials.push(serial);
      });
    }
    return serials;
  };

  getBaseGroupLocksRows = () => {
    const row = this.state.row || {};
    const base = [];

    _.map(row.groupLocks, (lockData) => {
      if (!lockData) return;

      base.push({
        id:
          lockData.snapID || `${lockData.ip45SerialNumber || ""}-${Date.now()}`,
        lockName: lockData.Name || "-",
        lockSerial: lockData.ip45SerialNumber || "-",
        shareMode: lockData.sharingMode || "NORMAL-GRP",
        startDate: lockData.shareStartTime || 0,
        endDate: lockData.shareEndTime || 0,
        access: lockData,
        source: "GROUP_MANAGEMENT",
      });
    });

    return base;
  };

  waitForSuperAdminID = async (timeoutMs = 5000) => {
    const start = Date.now();
    while (!this.state.superAdminID) {
      if (Date.now() - start > timeoutMs) return null;
      await new Promise((r) => setTimeout(r, 50));
    }
    return this.state.superAdminID;
  };

  mergeRowsBySerial = (baseRows, extraRows) => {
    const map = {};

    [...baseRows, ...extraRows].forEach((r) => {
      const key = r.lockSerial || r.id;
      if (!key) return;

      // prefer base row if already exists
      if (!map[key]) map[key] = r;
      else {
        const existing = map[key];
        map[key] = {
          ...r,
          ...existing, // existing wins
          lockName:
            existing.lockName && existing.lockName !== "-"
              ? existing.lockName
              : r.lockName,
        };
      }
    });

    return Object.values(map);
  };

  async handleGroupLocksPopupOpen() {
    this.setState({ isLoading: true });

    try {
      const {
        mergedRows,
        groupSharedInstances,
        superAdminInfo,
      } = await getMergedGroupLocks(this.state.row);

      this.setState({
        groupLocksArrayList: mergedRows,
        groupSharedInstances,
        showPopup: true,
        isAdmin: superAdminInfo?.isAdmin || false,
        isSuperAdmin: superAdminInfo?.isSuperAdmin || false,
        superAdminID: superAdminInfo?.superAdminID || "",
      });
    } catch (e) {
      console.error("handleGroupLocksPopupOpen error:", e);

      this.setState({
        groupLocksArrayList: [],
        groupSharedInstances: [],
        showPopup: true,
      });
    } finally {
      this.setState({ isLoading: false });
    }
  }

  // async handleGroupLocksPopupOpen() {
  //   this.setState({ isLoading: true });

  //   try {
  //     // ✅ always start from base locks (so you never "lose" them)
  //     const baseRows = this.getBaseGroupLocksRows();

  //     // ✅ ensure superAdminID is ready (otherwise fetch returns [])
  //     const superAdminID = await this.waitForSuperAdminID();
  //     if (!superAdminID) {
  //       console.warn("superAdminID not ready yet");
  //       this.setState({
  //         showPopup: true,
  //         groupLocksArrayList: baseRows,
  //       });
  //       return;
  //     }

  //     // 1) fetch sharedInstances
  //     const groupSharedInstances = await this.fetchGroupSharedInstances();

  //     // console.log("groupSharedInstances:", groupSharedInstances);

  //     // 2) lockGroupIds
  //     const lockGroupIds = Array.from(
  //       new Set(groupSharedInstances.map((x) => x.lockGroupId).filter(Boolean)),
  //     );

  //     // 3) userLocks map
  //     const userLocksMap = await this.fetchUserLocksMap();

  //     // 4) build extra rows from lockGroupManagement/locks
  //     const extraRows = [];
  //     for (const lockGroupId of lockGroupIds) {
  //       const serials = await this.fetchLockGroupLocksSerials(lockGroupId);

  //       serials.forEach((serial) => {
  //         const lockObj = userLocksMap[serial];

  //         extraRows.push({
  //           id: `${lockGroupId}:${serial}`,
  //           lockName: lockObj?.Name || "-",
  //           lockSerial: serial,
  //           shareMode: "NORMAL-GRP",
  //           startDate: 0,
  //           endDate: 0,
  //           lockGroupId,
  //           access: lockObj || {},
  //           source: "LOCK_GROUP_MANAGEMENT",
  //         });
  //       });
  //     }

  //     // ✅ merge without overriding
  //     const mergedRows = this.mergeRowsBySerial(baseRows, extraRows);

  //     // console.log("merged rows:", mergedRows);

  //     this.setState({
  //       groupSharedInstances,
  //       groupLocksArrayList: mergedRows,
  //       showPopup: true,
  //     });
  //   } catch (e) {
  //     console.error(e);

  //     // fallback: still show base rows
  //     this.setState({
  //       showPopup: true,
  //       groupLocksArrayList: this.getBaseGroupLocksRows(),
  //     });
  //   } finally {
  //     // ✅ loading always stops
  //     this.setState({ isLoading: false });
  //   }
  // }

  handleGroupLocksPopupClose() {
    this.setState({
      showPopup: false,
    });
  }

  // createCustomSearchField = props => {
  //   return (
  //     <SearchField
  //       className="searchBar"
  //       // id="retractSearch"
  //       placeholder="Search"
  //     />
  //   );
  // };

  // createCustomDeleteButton = onClick => {
  //   return (
  //     <Button
  //       bsSize="large"
  //       id="retractableBtn"
  //       style={{ width: "100%" }}
  //       onClick={onClick}
  //     >
  //       <i className="far fa-trash-alt" /> Remove Selected
  //     </Button>
  //   );
  // };

  // async onAfterDeleteRow(rowKeys) {
  // for (let i = 0; i < rowKeys.length; i++) {
  //   await deleteRetractableId(rowKeys[i], callback => {
  //     if (callback) {
  //       customLog("ok");
  //       this.showNotification("Lock access has been retracted!", "success");
  //     } else {
  //       customLog("fail");
  //       this.showNotification("Unable", "error");
  //     }
  //   });
  // }
  // }

  isASharedMode(shareMode) {
    if (shareMode === "NORMAL-GRP" || shareMode == null) {
      return localizationStrings.normalGrantAccess;
    } else if (shareMode === "MULTI-GRP") {
      return localizationStrings.multiApproveAccess;
    } else if (shareMode === "MULTI-OTA-GRP") {
      return localizationStrings.multiApproveOneTimeAccess;
    } else if (shareMode === "OTA-GRP") {
      return localizationStrings.oneTimeAccess;
    }
  }

  checkStartDate(shareStartTime) {
    if (shareStartTime === 0 || shareStartTime === "") {
      return "∞";
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        var japanDate =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(shareStartTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(shareStartTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(shareStartTime * 1000);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hourCycle: "h12",
          hour: "numeric",
          minute: "2-digit",
        }).format(shareStartTime * 1000);
        return japanDate + " " + japanTime;
      } else {
        // return <TimeStamp time={shareStartTime} format="full" includeDay />;
        return <TimeStamp time={shareStartTime} format="full" />;
      }
    }
  }

  checkEndDate(shareEndTime) {
    if (shareEndTime === 0 || shareEndTime === "") {
      return "∞";
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        var japanDate =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(shareEndTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(shareEndTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(shareEndTime * 1000);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hourCycle: "h12",
          hour: "numeric",
          minute: "2-digit",
        }).format(shareEndTime * 1000);
        return japanDate + " " + japanTime;
      } else {
        // return <TimeStamp time={shareEndTime} format="full" includeDay />;
        return <TimeStamp time={shareEndTime} format="full" />;
      }
    }
  }

  renderBtn(accessData) {
    // customLog(accessData);
    return <SwitchBtn accessData={accessData} accessID={this.state.groupID} />;
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{
          float: "right",
          color: "rgb(128, 128, 128)",
          fontWeight: "lighter",
        }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    const options = {
      // searchField: this.createCustomSearchField
      // deleteBtn: this.createCustomDeleteButton,
      // handleConfirmDeleteRow: customConfirmDialog,
      // afterDeleteRow: this.onAfterDeleteRow
      // hideSizePerPage: true
      page: 1, // which page you want to show as default
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: this.state.groupLocksArrayList.length,
        },
      ], // you can change the dropdown list for size per page
      sizePerPage: 10, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 3, // the pagination bar size.
      prePage: "<", // Previous page button text
      nextPage: ">", // Next page button text
      firstPage: "<<", // First page button text
      lastPage: ">>", // Last page button text
      paginationShowsTotal: customTotal,
      noDataText: localizationStrings.noDataTitle,
    };

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <Button
          onClick={this.handleGroupLocksPopupOpen}
          className="btn btn-info"
          style={{ borderRadius: "50px" }}
          disabled={this.state.isLoading}
        >
          {this.state.isLoading ? (
            <>
              <i className="fa fa-spinner fa-spin" style={{ marginRight: 8 }} />
              Loading...
            </>
          ) : (
            localizationStrings.viewLocksBtn
          )}
        </Button>
        {/* //! Popup for Group Locks Button */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handleGroupLocksPopupClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.groupLocksHeader}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <BootstrapTable
              data={this.state.groupLocksArrayList}
              bordered={false}
              pagination={true}
              options={options}
              // selectRow={{ mode: "checkbox", bgColor: "#eeeeee" }}
              // search
              // deleteRow
            >
              <TableHeaderColumn dataField="id" isKey={true} hidden>
                Key
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="lockName"
                dataSort
                columnTitle={columnHover}
              >
                {localizationStrings.nameHeader}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="lockSerial"
                dataSort
                columnTitle={columnHover}
              >
                {localizationStrings.lockSerialHeader}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="shareMode"
                dataFormat={this.isASharedMode}
                dataSort
                columnTitle={this.isASharedMode}
                tdStyle={{ whiteSpace: "normal" }}
              >
                {localizationStrings.shareModeHeader}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="startDate"
                dataFormat={this.checkStartDate}
                // columnTitle={this.checkStartDate}
                tdStyle={{ whiteSpace: "normal" }}
              >
                {localizationStrings.startHeader}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="endDate"
                dataFormat={this.checkEndDate}
                // columnTitle={this.checkEndDate}
                tdStyle={{ whiteSpace: "normal" }}
              >
                {localizationStrings.endHeader}
              </TableHeaderColumn>
              {/* <TableHeaderColumn dataField="access" dataFormat={this.renderBtn}>
                Allow Access
              </TableHeaderColumn> */}
            </BootstrapTable>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default LockDetailsButton;
